import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClearAllWrapper, NumSelected, SelectAllClearAllButton, } from './BKJSelectSearchControls.styled.js';
const LABELS = {
    fr: {
        SELECTED: 'Sélectionné',
        SELECT: 'Sélectionner',
        CLEAR: 'Claire',
        ALL: 'Toute',
    },
    en: {
        SELECTED: 'Selected',
        SELECT: 'Select',
        CLEAR: 'Clear',
        ALL: 'All',
    },
};
export const BKJSelectSearchControls = ({ numSelected, onSelectAll, isAllSelected, locale = 'en', }) => {
    const localeKey = locale in LABELS ? locale : 'en';
    const translationSet = LABELS[localeKey];
    return (_jsxs(ClearAllWrapper, { children: [_jsx(NumSelected, { children: `${numSelected} ${translationSet.SELECTED}` }), _jsx(SelectAllClearAllButton, { onClick: onSelectAll, children: `${isAllSelected ? translationSet.CLEAR : translationSet.SELECT} ${translationSet.ALL}` })] }));
};
//# sourceMappingURL=BKJSelectSearchControls.js.map